import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import { t } from '../../../../../modules/infra/i18n';
import config from '../../../../../config';

const HeadersList = ({ fields, className, showMaxLimit }) => {
  const importLimitValue = config.importLimit || 50000;
  
  return (
    <div className={className}>
      <p className="u-mb-" display-if={showMaxLimit}>
        <Trans 
          i18nKey="admin:import.headers.max_entries_message" 
          values={{ importLimit: importLimitValue }}
          components={{ 1: <strong /> }}
        />
      </p>
      {t('admin:import.headers.accepted_columns_message')}
      <ul className="u-ml">
        {
          fields.map(field => <li key={field}>{field}</li>)
        }
      </ul>
    </div>
  );
};

HeadersList.propTypes = {
  className: PropTypes.string,
  fields: PropTypes.array.isRequired,
  showMaxLimit: PropTypes.bool,
};

HeadersList.defaultProps = {
  className: '',
  showMaxLimit: false,
};

export default HeadersList;
